import { useQuery } from '@tanstack/react-query';
import { getOrganisations } from '@/fsd/entities/organization';
import { Option } from '@/fsd/shared/ui/CustomSelect/CustomSelect';

export const useOrganizationsSelectOptions = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['organisations'],
    queryFn: () => getOrganisations(),
  });

  const options: Option[] =
    data?.map((org) => ({
      name: org.name,
      value: String(org.id),
      id: org.id,
    })) || [];

  return { options, isLoading, isError };
};
